import { useEffect, useRef, useState } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { useNotification, useUserData } from '../../../../hooks'
import { CALENDAR_PREFERENCES_INITIAL } from '../../Calendar.constants'
import {
  getMockCalendarPreferences,
  updateMockCalendarPreferences,
} from '../../Calendar.mock'

export function useCalendarPreferences({ isEnabled = true } = EMPTY_OBJECT) {
  const { handleAddErrorNotification } = useNotification()

  const userData = useUserData()

  const [preferences, setPreferences] = useState(CALENDAR_PREFERENCES_INITIAL)
  const [isLoading, setLoading] = useState(true)

  const isReadStartedRef = useRef(false)

  // TODO: read and save the rail and the mode through the calendar preferences
  // endpoint once the backend serves it (TM-01-06).
  async function readPreferences() {
    return getMockCalendarPreferences(userData.id)
      .then(({ data }) => {
        setPreferences(data)
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  async function savePreferences(nextPreferences) {
    return updateMockCalendarPreferences({
      preferences: nextPreferences,
      userId: userData.id,
    }).catch(() => {
      handleAddErrorNotification('Error.CommonApiRequestFailKey')
    })
  }

  function handleChangePreferences(changes) {
    const nextPreferences = { ...preferences, ...changes }

    setPreferences(nextPreferences)

    savePreferences(nextPreferences)
  }

  useEffect(() => {
    if (isEnabled && !isReadStartedRef.current) {
      isReadStartedRef.current = true

      readPreferences()
    }
  }, [isEnabled])

  return { handleChangePreferences, isLoading, preferences }
}
